/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from "@tanstack/react-router";

import { Route as rootRouteImport } from "./routes/__root";
import { Route as ChangeLogRouteImport } from "./routes/change-log";
import { Route as AuthenticatedRouteRouteImport } from "./routes/_authenticated/route";
import { Route as IndexRouteImport } from "./routes/index";
import { Route as AccountResetPasswordRouteImport } from "./routes/account/reset-password";
import { Route as AccountLoginRouteImport } from "./routes/account/login";
import { Route as AccountForgotPasswordRouteImport } from "./routes/account/forgot-password";
import { Route as AccountConfirmEmailRouteImport } from "./routes/account/confirm-email";
import { Route as AuthenticatedReportRouteImport } from "./routes/_authenticated/report";
import { Route as AuthenticatedManagerRouteRouteImport } from "./routes/_authenticated/_manager/route";
import { Route as AuthenticatedAdminRouteRouteImport } from "./routes/_authenticated/_admin/route";
import { Route as AuthenticatedEntryTimeRouteImport } from "./routes/_authenticated/entry/time";
import { Route as AuthenticatedEntrySnapshotRouteImport } from "./routes/_authenticated/entry/snapshot";
import { Route as AuthenticatedEntryCreateRouteImport } from "./routes/_authenticated/entry/create";
import { Route as AuthenticatedEntryIdRouteImport } from "./routes/_authenticated/entry/$id";
import { Route as AuthenticatedAccountProfileRouteImport } from "./routes/_authenticated/account/profile";
import { Route as AuthenticatedAccountChangePasswordRouteImport } from "./routes/_authenticated/account/change-password";
import { Route as AuthenticatedManagerReportingRouteRouteImport } from "./routes/_authenticated/_manager/reporting/route";
import { Route as AuthenticatedAdminAdminRouteRouteImport } from "./routes/_authenticated/_admin/admin/route";
import { Route as AuthenticatedManagerStaffIndexRouteImport } from "./routes/_authenticated/_manager/staff/index";
import { Route as AuthenticatedManagerInvoiceIndexRouteImport } from "./routes/_authenticated/_manager/invoice/index";
import { Route as AuthenticatedManagerClientIndexRouteImport } from "./routes/_authenticated/_manager/client/index";
import { Route as AuthenticatedManagerAssignmentIndexRouteImport } from "./routes/_authenticated/_manager/assignment/index";
import { Route as AuthenticatedManagerStaffCreateRouteImport } from "./routes/_authenticated/_manager/staff/create";
import { Route as AuthenticatedManagerStaffIdRouteImport } from "./routes/_authenticated/_manager/staff/$id";
import { Route as AuthenticatedManagerInvoiceCreateRouteImport } from "./routes/_authenticated/_manager/invoice/create";
import { Route as AuthenticatedManagerClientCreateRouteImport } from "./routes/_authenticated/_manager/client/create";
import { Route as AuthenticatedManagerClientIdRouteImport } from "./routes/_authenticated/_manager/client/$id";
import { Route as AuthenticatedManagerAssignmentAssignmentIdRouteImport } from "./routes/_authenticated/_manager/assignment/$assignmentId";
import { Route as AuthenticatedAdminAdminPowerBiRouteImport } from "./routes/_authenticated/_admin/admin/power-bi";
import { Route as AuthenticatedAdminAdminOtherRouteImport } from "./routes/_authenticated/_admin/admin/other";
import { Route as AuthenticatedAdminAdminExpenseRouteImport } from "./routes/_authenticated/_admin/admin/expense";
import { Route as AuthenticatedAdminAdminAssignmentRouteImport } from "./routes/_authenticated/_admin/admin/assignment";
import { Route as AuthenticatedManagerInvoiceInvoiceIdIndexRouteImport } from "./routes/_authenticated/_manager/invoice/$invoiceId/index";
import { Route as AuthenticatedManagerInvoiceInvoiceIdEditRouteImport } from "./routes/_authenticated/_manager/invoice/$invoiceId/edit";
import { Route as AuthenticatedManagerAssignmentCreateClientIdRouteImport } from "./routes/_authenticated/_manager/assignment/create.$clientId";
import { Route as AuthenticatedAdminAdminPowerBiSettingsRouteImport } from "./routes/_authenticated/_admin/admin/power-bi/settings";
import { Route as AuthenticatedAdminAdminOtherSystemInfoRouteImport } from "./routes/_authenticated/_admin/admin/other/system-info";
import { Route as AuthenticatedManagerInvoiceInvoiceIdAdjustmentCreateRouteImport } from "./routes/_authenticated/_manager/invoice/$invoiceId/adjustment.create";

const AuthenticatedManagerReportingIdLazyRouteImport = createFileRoute(
  "/_authenticated/_manager/reporting/$id",
)();
const AuthenticatedAdminAdminOtherStateCodesLazyRouteImport = createFileRoute(
  "/_authenticated/_admin/admin/other/state-codes",
)();
const AuthenticatedAdminAdminOtherClientCategoriesLazyRouteImport =
  createFileRoute("/_authenticated/_admin/admin/other/client-categories")();
const AuthenticatedAdminAdminExpenseTimeExpenseCategoriesLazyRouteImport =
  createFileRoute(
    "/_authenticated/_admin/admin/expense/time-expense-categories",
  )();
const AuthenticatedAdminAdminExpenseSubcategoryGroupsLazyRouteImport =
  createFileRoute("/_authenticated/_admin/admin/expense/subcategory-groups")();
const AuthenticatedAdminAdminExpenseReimbursableExpenseExceptionsLazyRouteImport =
  createFileRoute(
    "/_authenticated/_admin/admin/expense/reimbursable-expense-exceptions",
  )();
const AuthenticatedAdminAdminExpenseExpenseSubcategoriesLazyRouteImport =
  createFileRoute(
    "/_authenticated/_admin/admin/expense/expense-subcategories",
  )();
const AuthenticatedAdminAdminExpenseAccountingCodesLazyRouteImport =
  createFileRoute("/_authenticated/_admin/admin/expense/accounting-codes")();
const AuthenticatedAdminAdminExpenseAccountingCategoriesLazyRouteImport =
  createFileRoute(
    "/_authenticated/_admin/admin/expense/accounting-categories",
  )();
const AuthenticatedAdminAdminAssignmentWpRoleCodesLazyRouteImport =
  createFileRoute("/_authenticated/_admin/admin/assignment/wp-role-codes")();
const AuthenticatedAdminAdminAssignmentWorkLocationsLazyRouteImport =
  createFileRoute("/_authenticated/_admin/admin/assignment/work-locations")();
const AuthenticatedAdminAdminAssignmentUtilizationCodesLazyRouteImport =
  createFileRoute(
    "/_authenticated/_admin/admin/assignment/utilization-codes",
  )();
const AuthenticatedAdminAdminAssignmentInvoiceTypesLazyRouteImport =
  createFileRoute("/_authenticated/_admin/admin/assignment/invoice-types")();
const AuthenticatedAdminAdminAssignmentInvoicePrintStylesLazyRouteImport =
  createFileRoute(
    "/_authenticated/_admin/admin/assignment/invoice-print-styles",
  )();
const AuthenticatedAdminAdminAssignmentExtensionsLazyRouteImport =
  createFileRoute("/_authenticated/_admin/admin/assignment/extensions")();
const AuthenticatedAdminAdminAssignmentBillingTermsLazyRouteImport =
  createFileRoute("/_authenticated/_admin/admin/assignment/billing-terms")();

const ChangeLogRoute = ChangeLogRouteImport.update({
  id: "/change-log",
  path: "/change-log",
  getParentRoute: () => rootRouteImport,
} as any);
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: "/_authenticated",
  getParentRoute: () => rootRouteImport,
} as any);
const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any);
const AccountResetPasswordRoute = AccountResetPasswordRouteImport.update({
  id: "/account/reset-password",
  path: "/account/reset-password",
  getParentRoute: () => rootRouteImport,
} as any);
const AccountLoginRoute = AccountLoginRouteImport.update({
  id: "/account/login",
  path: "/account/login",
  getParentRoute: () => rootRouteImport,
} as any);
const AccountForgotPasswordRoute = AccountForgotPasswordRouteImport.update({
  id: "/account/forgot-password",
  path: "/account/forgot-password",
  getParentRoute: () => rootRouteImport,
} as any);
const AccountConfirmEmailRoute = AccountConfirmEmailRouteImport.update({
  id: "/account/confirm-email",
  path: "/account/confirm-email",
  getParentRoute: () => rootRouteImport,
} as any);
const AuthenticatedReportRoute = AuthenticatedReportRouteImport.update({
  id: "/report",
  path: "/report",
  getParentRoute: () => AuthenticatedRouteRoute,
} as any);
const AuthenticatedManagerRouteRoute =
  AuthenticatedManagerRouteRouteImport.update({
    id: "/_manager",
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any);
const AuthenticatedAdminRouteRoute = AuthenticatedAdminRouteRouteImport.update({
  id: "/_admin",
  getParentRoute: () => AuthenticatedRouteRoute,
} as any);
const AuthenticatedEntryTimeRoute = AuthenticatedEntryTimeRouteImport.update({
  id: "/entry/time",
  path: "/entry/time",
  getParentRoute: () => AuthenticatedRouteRoute,
} as any);
const AuthenticatedEntrySnapshotRoute =
  AuthenticatedEntrySnapshotRouteImport.update({
    id: "/entry/snapshot",
    path: "/entry/snapshot",
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any);
const AuthenticatedEntryCreateRoute =
  AuthenticatedEntryCreateRouteImport.update({
    id: "/entry/create",
    path: "/entry/create",
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any);
const AuthenticatedEntryIdRoute = AuthenticatedEntryIdRouteImport.update({
  id: "/entry/$id",
  path: "/entry/$id",
  getParentRoute: () => AuthenticatedRouteRoute,
} as any);
const AuthenticatedAccountProfileRoute =
  AuthenticatedAccountProfileRouteImport.update({
    id: "/account/profile",
    path: "/account/profile",
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any);
const AuthenticatedAccountChangePasswordRoute =
  AuthenticatedAccountChangePasswordRouteImport.update({
    id: "/account/change-password",
    path: "/account/change-password",
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any);
const AuthenticatedManagerReportingRouteRoute =
  AuthenticatedManagerReportingRouteRouteImport.update({
    id: "/reporting",
    path: "/reporting",
    getParentRoute: () => AuthenticatedManagerRouteRoute,
  } as any);
const AuthenticatedAdminAdminRouteRoute =
  AuthenticatedAdminAdminRouteRouteImport.update({
    id: "/admin",
    path: "/admin",
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any);
const AuthenticatedManagerStaffIndexRoute =
  AuthenticatedManagerStaffIndexRouteImport.update({
    id: "/staff/",
    path: "/staff/",
    getParentRoute: () => AuthenticatedManagerRouteRoute,
  } as any);
const AuthenticatedManagerInvoiceIndexRoute =
  AuthenticatedManagerInvoiceIndexRouteImport.update({
    id: "/invoice/",
    path: "/invoice/",
    getParentRoute: () => AuthenticatedManagerRouteRoute,
  } as any);
const AuthenticatedManagerClientIndexRoute =
  AuthenticatedManagerClientIndexRouteImport.update({
    id: "/client/",
    path: "/client/",
    getParentRoute: () => AuthenticatedManagerRouteRoute,
  } as any);
const AuthenticatedManagerAssignmentIndexRoute =
  AuthenticatedManagerAssignmentIndexRouteImport.update({
    id: "/assignment/",
    path: "/assignment/",
    getParentRoute: () => AuthenticatedManagerRouteRoute,
  } as any);
const AuthenticatedManagerReportingIdLazyRoute =
  AuthenticatedManagerReportingIdLazyRouteImport.update({
    id: "/$id",
    path: "/$id",
    getParentRoute: () => AuthenticatedManagerReportingRouteRoute,
  } as any).lazy(() =>
    import("./routes/_authenticated/_manager/reporting/$id.lazy").then(
      (d) => d.Route,
    ),
  );
const AuthenticatedManagerStaffCreateRoute =
  AuthenticatedManagerStaffCreateRouteImport.update({
    id: "/staff/create",
    path: "/staff/create",
    getParentRoute: () => AuthenticatedManagerRouteRoute,
  } as any);
const AuthenticatedManagerStaffIdRoute =
  AuthenticatedManagerStaffIdRouteImport.update({
    id: "/staff/$id",
    path: "/staff/$id",
    getParentRoute: () => AuthenticatedManagerRouteRoute,
  } as any);
const AuthenticatedManagerInvoiceCreateRoute =
  AuthenticatedManagerInvoiceCreateRouteImport.update({
    id: "/invoice/create",
    path: "/invoice/create",
    getParentRoute: () => AuthenticatedManagerRouteRoute,
  } as any);
const AuthenticatedManagerClientCreateRoute =
  AuthenticatedManagerClientCreateRouteImport.update({
    id: "/client/create",
    path: "/client/create",
    getParentRoute: () => AuthenticatedManagerRouteRoute,
  } as any);
const AuthenticatedManagerClientIdRoute =
  AuthenticatedManagerClientIdRouteImport.update({
    id: "/client/$id",
    path: "/client/$id",
    getParentRoute: () => AuthenticatedManagerRouteRoute,
  } as any);
const AuthenticatedManagerAssignmentAssignmentIdRoute =
  AuthenticatedManagerAssignmentAssignmentIdRouteImport.update({
    id: "/assignment/$assignmentId",
    path: "/assignment/$assignmentId",
    getParentRoute: () => AuthenticatedManagerRouteRoute,
  } as any);
const AuthenticatedAdminAdminPowerBiRoute =
  AuthenticatedAdminAdminPowerBiRouteImport.update({
    id: "/power-bi",
    path: "/power-bi",
    getParentRoute: () => AuthenticatedAdminAdminRouteRoute,
  } as any);
const AuthenticatedAdminAdminOtherRoute =
  AuthenticatedAdminAdminOtherRouteImport.update({
    id: "/other",
    path: "/other",
    getParentRoute: () => AuthenticatedAdminAdminRouteRoute,
  } as any);
const AuthenticatedAdminAdminExpenseRoute =
  AuthenticatedAdminAdminExpenseRouteImport.update({
    id: "/expense",
    path: "/expense",
    getParentRoute: () => AuthenticatedAdminAdminRouteRoute,
  } as any);
const AuthenticatedAdminAdminAssignmentRoute =
  AuthenticatedAdminAdminAssignmentRouteImport.update({
    id: "/assignment",
    path: "/assignment",
    getParentRoute: () => AuthenticatedAdminAdminRouteRoute,
  } as any);
const AuthenticatedManagerInvoiceInvoiceIdIndexRoute =
  AuthenticatedManagerInvoiceInvoiceIdIndexRouteImport.update({
    id: "/invoice/$invoiceId/",
    path: "/invoice/$invoiceId/",
    getParentRoute: () => AuthenticatedManagerRouteRoute,
  } as any);
const AuthenticatedAdminAdminOtherStateCodesLazyRoute =
  AuthenticatedAdminAdminOtherStateCodesLazyRouteImport.update({
    id: "/state-codes",
    path: "/state-codes",
    getParentRoute: () => AuthenticatedAdminAdminOtherRoute,
  } as any).lazy(() =>
    import("./routes/_authenticated/_admin/admin/other/state-codes.lazy").then(
      (d) => d.Route,
    ),
  );
const AuthenticatedAdminAdminOtherClientCategoriesLazyRoute =
  AuthenticatedAdminAdminOtherClientCategoriesLazyRouteImport.update({
    id: "/client-categories",
    path: "/client-categories",
    getParentRoute: () => AuthenticatedAdminAdminOtherRoute,
  } as any).lazy(() =>
    import(
      "./routes/_authenticated/_admin/admin/other/client-categories.lazy"
    ).then((d) => d.Route),
  );
const AuthenticatedAdminAdminExpenseTimeExpenseCategoriesLazyRoute =
  AuthenticatedAdminAdminExpenseTimeExpenseCategoriesLazyRouteImport.update({
    id: "/time-expense-categories",
    path: "/time-expense-categories",
    getParentRoute: () => AuthenticatedAdminAdminExpenseRoute,
  } as any).lazy(() =>
    import(
      "./routes/_authenticated/_admin/admin/expense/time-expense-categories.lazy"
    ).then((d) => d.Route),
  );
const AuthenticatedAdminAdminExpenseSubcategoryGroupsLazyRoute =
  AuthenticatedAdminAdminExpenseSubcategoryGroupsLazyRouteImport.update({
    id: "/subcategory-groups",
    path: "/subcategory-groups",
    getParentRoute: () => AuthenticatedAdminAdminExpenseRoute,
  } as any).lazy(() =>
    import(
      "./routes/_authenticated/_admin/admin/expense/subcategory-groups.lazy"
    ).then((d) => d.Route),
  );
const AuthenticatedAdminAdminExpenseReimbursableExpenseExceptionsLazyRoute =
  AuthenticatedAdminAdminExpenseReimbursableExpenseExceptionsLazyRouteImport.update(
    {
      id: "/reimbursable-expense-exceptions",
      path: "/reimbursable-expense-exceptions",
      getParentRoute: () => AuthenticatedAdminAdminExpenseRoute,
    } as any,
  ).lazy(() =>
    import(
      "./routes/_authenticated/_admin/admin/expense/reimbursable-expense-exceptions.lazy"
    ).then((d) => d.Route),
  );
const AuthenticatedAdminAdminExpenseExpenseSubcategoriesLazyRoute =
  AuthenticatedAdminAdminExpenseExpenseSubcategoriesLazyRouteImport.update({
    id: "/expense-subcategories",
    path: "/expense-subcategories",
    getParentRoute: () => AuthenticatedAdminAdminExpenseRoute,
  } as any).lazy(() =>
    import(
      "./routes/_authenticated/_admin/admin/expense/expense-subcategories.lazy"
    ).then((d) => d.Route),
  );
const AuthenticatedAdminAdminExpenseAccountingCodesLazyRoute =
  AuthenticatedAdminAdminExpenseAccountingCodesLazyRouteImport.update({
    id: "/accounting-codes",
    path: "/accounting-codes",
    getParentRoute: () => AuthenticatedAdminAdminExpenseRoute,
  } as any).lazy(() =>
    import(
      "./routes/_authenticated/_admin/admin/expense/accounting-codes.lazy"
    ).then((d) => d.Route),
  );
const AuthenticatedAdminAdminExpenseAccountingCategoriesLazyRoute =
  AuthenticatedAdminAdminExpenseAccountingCategoriesLazyRouteImport.update({
    id: "/accounting-categories",
    path: "/accounting-categories",
    getParentRoute: () => AuthenticatedAdminAdminExpenseRoute,
  } as any).lazy(() =>
    import(
      "./routes/_authenticated/_admin/admin/expense/accounting-categories.lazy"
    ).then((d) => d.Route),
  );
const AuthenticatedAdminAdminAssignmentWpRoleCodesLazyRoute =
  AuthenticatedAdminAdminAssignmentWpRoleCodesLazyRouteImport.update({
    id: "/wp-role-codes",
    path: "/wp-role-codes",
    getParentRoute: () => AuthenticatedAdminAdminAssignmentRoute,
  } as any).lazy(() =>
    import(
      "./routes/_authenticated/_admin/admin/assignment/wp-role-codes.lazy"
    ).then((d) => d.Route),
  );
const AuthenticatedAdminAdminAssignmentWorkLocationsLazyRoute =
  AuthenticatedAdminAdminAssignmentWorkLocationsLazyRouteImport.update({
    id: "/work-locations",
    path: "/work-locations",
    getParentRoute: () => AuthenticatedAdminAdminAssignmentRoute,
  } as any).lazy(() =>
    import(
      "./routes/_authenticated/_admin/admin/assignment/work-locations.lazy"
    ).then((d) => d.Route),
  );
const AuthenticatedAdminAdminAssignmentUtilizationCodesLazyRoute =
  AuthenticatedAdminAdminAssignmentUtilizationCodesLazyRouteImport.update({
    id: "/utilization-codes",
    path: "/utilization-codes",
    getParentRoute: () => AuthenticatedAdminAdminAssignmentRoute,
  } as any).lazy(() =>
    import(
      "./routes/_authenticated/_admin/admin/assignment/utilization-codes.lazy"
    ).then((d) => d.Route),
  );
const AuthenticatedAdminAdminAssignmentInvoiceTypesLazyRoute =
  AuthenticatedAdminAdminAssignmentInvoiceTypesLazyRouteImport.update({
    id: "/invoice-types",
    path: "/invoice-types",
    getParentRoute: () => AuthenticatedAdminAdminAssignmentRoute,
  } as any).lazy(() =>
    import(
      "./routes/_authenticated/_admin/admin/assignment/invoice-types.lazy"
    ).then((d) => d.Route),
  );
const AuthenticatedAdminAdminAssignmentInvoicePrintStylesLazyRoute =
  AuthenticatedAdminAdminAssignmentInvoicePrintStylesLazyRouteImport.update({
    id: "/invoice-print-styles",
    path: "/invoice-print-styles",
    getParentRoute: () => AuthenticatedAdminAdminAssignmentRoute,
  } as any).lazy(() =>
    import(
      "./routes/_authenticated/_admin/admin/assignment/invoice-print-styles.lazy"
    ).then((d) => d.Route),
  );
const AuthenticatedAdminAdminAssignmentExtensionsLazyRoute =
  AuthenticatedAdminAdminAssignmentExtensionsLazyRouteImport.update({
    id: "/extensions",
    path: "/extensions",
    getParentRoute: () => AuthenticatedAdminAdminAssignmentRoute,
  } as any).lazy(() =>
    import(
      "./routes/_authenticated/_admin/admin/assignment/extensions.lazy"
    ).then((d) => d.Route),
  );
const AuthenticatedAdminAdminAssignmentBillingTermsLazyRoute =
  AuthenticatedAdminAdminAssignmentBillingTermsLazyRouteImport.update({
    id: "/billing-terms",
    path: "/billing-terms",
    getParentRoute: () => AuthenticatedAdminAdminAssignmentRoute,
  } as any).lazy(() =>
    import(
      "./routes/_authenticated/_admin/admin/assignment/billing-terms.lazy"
    ).then((d) => d.Route),
  );
const AuthenticatedManagerInvoiceInvoiceIdEditRoute =
  AuthenticatedManagerInvoiceInvoiceIdEditRouteImport.update({
    id: "/invoice/$invoiceId/edit",
    path: "/invoice/$invoiceId/edit",
    getParentRoute: () => AuthenticatedManagerRouteRoute,
  } as any);
const AuthenticatedManagerAssignmentCreateClientIdRoute =
  AuthenticatedManagerAssignmentCreateClientIdRouteImport.update({
    id: "/assignment/create/$clientId",
    path: "/assignment/create/$clientId",
    getParentRoute: () => AuthenticatedManagerRouteRoute,
  } as any);
const AuthenticatedAdminAdminPowerBiSettingsRoute =
  AuthenticatedAdminAdminPowerBiSettingsRouteImport.update({
    id: "/settings",
    path: "/settings",
    getParentRoute: () => AuthenticatedAdminAdminPowerBiRoute,
  } as any);
const AuthenticatedAdminAdminOtherSystemInfoRoute =
  AuthenticatedAdminAdminOtherSystemInfoRouteImport.update({
    id: "/system-info",
    path: "/system-info",
    getParentRoute: () => AuthenticatedAdminAdminOtherRoute,
  } as any);
const AuthenticatedManagerInvoiceInvoiceIdAdjustmentCreateRoute =
  AuthenticatedManagerInvoiceInvoiceIdAdjustmentCreateRouteImport.update({
    id: "/invoice/$invoiceId/adjustment/create",
    path: "/invoice/$invoiceId/adjustment/create",
    getParentRoute: () => AuthenticatedManagerRouteRoute,
  } as any);

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute;
  "/change-log": typeof ChangeLogRoute;
  "/report": typeof AuthenticatedReportRoute;
  "/account/confirm-email": typeof AccountConfirmEmailRoute;
  "/account/forgot-password": typeof AccountForgotPasswordRoute;
  "/account/login": typeof AccountLoginRoute;
  "/account/reset-password": typeof AccountResetPasswordRoute;
  "/admin": typeof AuthenticatedAdminAdminRouteRouteWithChildren;
  "/reporting": typeof AuthenticatedManagerReportingRouteRouteWithChildren;
  "/account/change-password": typeof AuthenticatedAccountChangePasswordRoute;
  "/account/profile": typeof AuthenticatedAccountProfileRoute;
  "/entry/$id": typeof AuthenticatedEntryIdRoute;
  "/entry/create": typeof AuthenticatedEntryCreateRoute;
  "/entry/snapshot": typeof AuthenticatedEntrySnapshotRoute;
  "/entry/time": typeof AuthenticatedEntryTimeRoute;
  "/admin/assignment": typeof AuthenticatedAdminAdminAssignmentRouteWithChildren;
  "/admin/expense": typeof AuthenticatedAdminAdminExpenseRouteWithChildren;
  "/admin/other": typeof AuthenticatedAdminAdminOtherRouteWithChildren;
  "/admin/power-bi": typeof AuthenticatedAdminAdminPowerBiRouteWithChildren;
  "/assignment/$assignmentId": typeof AuthenticatedManagerAssignmentAssignmentIdRoute;
  "/client/$id": typeof AuthenticatedManagerClientIdRoute;
  "/client/create": typeof AuthenticatedManagerClientCreateRoute;
  "/invoice/create": typeof AuthenticatedManagerInvoiceCreateRoute;
  "/staff/$id": typeof AuthenticatedManagerStaffIdRoute;
  "/staff/create": typeof AuthenticatedManagerStaffCreateRoute;
  "/reporting/$id": typeof AuthenticatedManagerReportingIdLazyRoute;
  "/assignment": typeof AuthenticatedManagerAssignmentIndexRoute;
  "/client": typeof AuthenticatedManagerClientIndexRoute;
  "/invoice": typeof AuthenticatedManagerInvoiceIndexRoute;
  "/staff": typeof AuthenticatedManagerStaffIndexRoute;
  "/admin/other/system-info": typeof AuthenticatedAdminAdminOtherSystemInfoRoute;
  "/admin/power-bi/settings": typeof AuthenticatedAdminAdminPowerBiSettingsRoute;
  "/assignment/create/$clientId": typeof AuthenticatedManagerAssignmentCreateClientIdRoute;
  "/invoice/$invoiceId/edit": typeof AuthenticatedManagerInvoiceInvoiceIdEditRoute;
  "/admin/assignment/billing-terms": typeof AuthenticatedAdminAdminAssignmentBillingTermsLazyRoute;
  "/admin/assignment/extensions": typeof AuthenticatedAdminAdminAssignmentExtensionsLazyRoute;
  "/admin/assignment/invoice-print-styles": typeof AuthenticatedAdminAdminAssignmentInvoicePrintStylesLazyRoute;
  "/admin/assignment/invoice-types": typeof AuthenticatedAdminAdminAssignmentInvoiceTypesLazyRoute;
  "/admin/assignment/utilization-codes": typeof AuthenticatedAdminAdminAssignmentUtilizationCodesLazyRoute;
  "/admin/assignment/work-locations": typeof AuthenticatedAdminAdminAssignmentWorkLocationsLazyRoute;
  "/admin/assignment/wp-role-codes": typeof AuthenticatedAdminAdminAssignmentWpRoleCodesLazyRoute;
  "/admin/expense/accounting-categories": typeof AuthenticatedAdminAdminExpenseAccountingCategoriesLazyRoute;
  "/admin/expense/accounting-codes": typeof AuthenticatedAdminAdminExpenseAccountingCodesLazyRoute;
  "/admin/expense/expense-subcategories": typeof AuthenticatedAdminAdminExpenseExpenseSubcategoriesLazyRoute;
  "/admin/expense/reimbursable-expense-exceptions": typeof AuthenticatedAdminAdminExpenseReimbursableExpenseExceptionsLazyRoute;
  "/admin/expense/subcategory-groups": typeof AuthenticatedAdminAdminExpenseSubcategoryGroupsLazyRoute;
  "/admin/expense/time-expense-categories": typeof AuthenticatedAdminAdminExpenseTimeExpenseCategoriesLazyRoute;
  "/admin/other/client-categories": typeof AuthenticatedAdminAdminOtherClientCategoriesLazyRoute;
  "/admin/other/state-codes": typeof AuthenticatedAdminAdminOtherStateCodesLazyRoute;
  "/invoice/$invoiceId": typeof AuthenticatedManagerInvoiceInvoiceIdIndexRoute;
  "/invoice/$invoiceId/adjustment/create": typeof AuthenticatedManagerInvoiceInvoiceIdAdjustmentCreateRoute;
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute;
  "/change-log": typeof ChangeLogRoute;
  "/report": typeof AuthenticatedReportRoute;
  "/account/confirm-email": typeof AccountConfirmEmailRoute;
  "/account/forgot-password": typeof AccountForgotPasswordRoute;
  "/account/login": typeof AccountLoginRoute;
  "/account/reset-password": typeof AccountResetPasswordRoute;
  "/admin": typeof AuthenticatedAdminAdminRouteRouteWithChildren;
  "/reporting": typeof AuthenticatedManagerReportingRouteRouteWithChildren;
  "/account/change-password": typeof AuthenticatedAccountChangePasswordRoute;
  "/account/profile": typeof AuthenticatedAccountProfileRoute;
  "/entry/$id": typeof AuthenticatedEntryIdRoute;
  "/entry/create": typeof AuthenticatedEntryCreateRoute;
  "/entry/snapshot": typeof AuthenticatedEntrySnapshotRoute;
  "/entry/time": typeof AuthenticatedEntryTimeRoute;
  "/admin/assignment": typeof AuthenticatedAdminAdminAssignmentRouteWithChildren;
  "/admin/expense": typeof AuthenticatedAdminAdminExpenseRouteWithChildren;
  "/admin/other": typeof AuthenticatedAdminAdminOtherRouteWithChildren;
  "/admin/power-bi": typeof AuthenticatedAdminAdminPowerBiRouteWithChildren;
  "/assignment/$assignmentId": typeof AuthenticatedManagerAssignmentAssignmentIdRoute;
  "/client/$id": typeof AuthenticatedManagerClientIdRoute;
  "/client/create": typeof AuthenticatedManagerClientCreateRoute;
  "/invoice/create": typeof AuthenticatedManagerInvoiceCreateRoute;
  "/staff/$id": typeof AuthenticatedManagerStaffIdRoute;
  "/staff/create": typeof AuthenticatedManagerStaffCreateRoute;
  "/reporting/$id": typeof AuthenticatedManagerReportingIdLazyRoute;
  "/assignment": typeof AuthenticatedManagerAssignmentIndexRoute;
  "/client": typeof AuthenticatedManagerClientIndexRoute;
  "/invoice": typeof AuthenticatedManagerInvoiceIndexRoute;
  "/staff": typeof AuthenticatedManagerStaffIndexRoute;
  "/admin/other/system-info": typeof AuthenticatedAdminAdminOtherSystemInfoRoute;
  "/admin/power-bi/settings": typeof AuthenticatedAdminAdminPowerBiSettingsRoute;
  "/assignment/create/$clientId": typeof AuthenticatedManagerAssignmentCreateClientIdRoute;
  "/invoice/$invoiceId/edit": typeof AuthenticatedManagerInvoiceInvoiceIdEditRoute;
  "/admin/assignment/billing-terms": typeof AuthenticatedAdminAdminAssignmentBillingTermsLazyRoute;
  "/admin/assignment/extensions": typeof AuthenticatedAdminAdminAssignmentExtensionsLazyRoute;
  "/admin/assignment/invoice-print-styles": typeof AuthenticatedAdminAdminAssignmentInvoicePrintStylesLazyRoute;
  "/admin/assignment/invoice-types": typeof AuthenticatedAdminAdminAssignmentInvoiceTypesLazyRoute;
  "/admin/assignment/utilization-codes": typeof AuthenticatedAdminAdminAssignmentUtilizationCodesLazyRoute;
  "/admin/assignment/work-locations": typeof AuthenticatedAdminAdminAssignmentWorkLocationsLazyRoute;
  "/admin/assignment/wp-role-codes": typeof AuthenticatedAdminAdminAssignmentWpRoleCodesLazyRoute;
  "/admin/expense/accounting-categories": typeof AuthenticatedAdminAdminExpenseAccountingCategoriesLazyRoute;
  "/admin/expense/accounting-codes": typeof AuthenticatedAdminAdminExpenseAccountingCodesLazyRoute;
  "/admin/expense/expense-subcategories": typeof AuthenticatedAdminAdminExpenseExpenseSubcategoriesLazyRoute;
  "/admin/expense/reimbursable-expense-exceptions": typeof AuthenticatedAdminAdminExpenseReimbursableExpenseExceptionsLazyRoute;
  "/admin/expense/subcategory-groups": typeof AuthenticatedAdminAdminExpenseSubcategoryGroupsLazyRoute;
  "/admin/expense/time-expense-categories": typeof AuthenticatedAdminAdminExpenseTimeExpenseCategoriesLazyRoute;
  "/admin/other/client-categories": typeof AuthenticatedAdminAdminOtherClientCategoriesLazyRoute;
  "/admin/other/state-codes": typeof AuthenticatedAdminAdminOtherStateCodesLazyRoute;
  "/invoice/$invoiceId": typeof AuthenticatedManagerInvoiceInvoiceIdIndexRoute;
  "/invoice/$invoiceId/adjustment/create": typeof AuthenticatedManagerInvoiceInvoiceIdAdjustmentCreateRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  "/": typeof IndexRoute;
  "/_authenticated": typeof AuthenticatedRouteRouteWithChildren;
  "/change-log": typeof ChangeLogRoute;
  "/_authenticated/_admin": typeof AuthenticatedAdminRouteRouteWithChildren;
  "/_authenticated/_manager": typeof AuthenticatedManagerRouteRouteWithChildren;
  "/_authenticated/report": typeof AuthenticatedReportRoute;
  "/account/confirm-email": typeof AccountConfirmEmailRoute;
  "/account/forgot-password": typeof AccountForgotPasswordRoute;
  "/account/login": typeof AccountLoginRoute;
  "/account/reset-password": typeof AccountResetPasswordRoute;
  "/_authenticated/_admin/admin": typeof AuthenticatedAdminAdminRouteRouteWithChildren;
  "/_authenticated/_manager/reporting": typeof AuthenticatedManagerReportingRouteRouteWithChildren;
  "/_authenticated/account/change-password": typeof AuthenticatedAccountChangePasswordRoute;
  "/_authenticated/account/profile": typeof AuthenticatedAccountProfileRoute;
  "/_authenticated/entry/$id": typeof AuthenticatedEntryIdRoute;
  "/_authenticated/entry/create": typeof AuthenticatedEntryCreateRoute;
  "/_authenticated/entry/snapshot": typeof AuthenticatedEntrySnapshotRoute;
  "/_authenticated/entry/time": typeof AuthenticatedEntryTimeRoute;
  "/_authenticated/_admin/admin/assignment": typeof AuthenticatedAdminAdminAssignmentRouteWithChildren;
  "/_authenticated/_admin/admin/expense": typeof AuthenticatedAdminAdminExpenseRouteWithChildren;
  "/_authenticated/_admin/admin/other": typeof AuthenticatedAdminAdminOtherRouteWithChildren;
  "/_authenticated/_admin/admin/power-bi": typeof AuthenticatedAdminAdminPowerBiRouteWithChildren;
  "/_authenticated/_manager/assignment/$assignmentId": typeof AuthenticatedManagerAssignmentAssignmentIdRoute;
  "/_authenticated/_manager/client/$id": typeof AuthenticatedManagerClientIdRoute;
  "/_authenticated/_manager/client/create": typeof AuthenticatedManagerClientCreateRoute;
  "/_authenticated/_manager/invoice/create": typeof AuthenticatedManagerInvoiceCreateRoute;
  "/_authenticated/_manager/staff/$id": typeof AuthenticatedManagerStaffIdRoute;
  "/_authenticated/_manager/staff/create": typeof AuthenticatedManagerStaffCreateRoute;
  "/_authenticated/_manager/reporting/$id": typeof AuthenticatedManagerReportingIdLazyRoute;
  "/_authenticated/_manager/assignment/": typeof AuthenticatedManagerAssignmentIndexRoute;
  "/_authenticated/_manager/client/": typeof AuthenticatedManagerClientIndexRoute;
  "/_authenticated/_manager/invoice/": typeof AuthenticatedManagerInvoiceIndexRoute;
  "/_authenticated/_manager/staff/": typeof AuthenticatedManagerStaffIndexRoute;
  "/_authenticated/_admin/admin/other/system-info": typeof AuthenticatedAdminAdminOtherSystemInfoRoute;
  "/_authenticated/_admin/admin/power-bi/settings": typeof AuthenticatedAdminAdminPowerBiSettingsRoute;
  "/_authenticated/_manager/assignment/create/$clientId": typeof AuthenticatedManagerAssignmentCreateClientIdRoute;
  "/_authenticated/_manager/invoice/$invoiceId/edit": typeof AuthenticatedManagerInvoiceInvoiceIdEditRoute;
  "/_authenticated/_admin/admin/assignment/billing-terms": typeof AuthenticatedAdminAdminAssignmentBillingTermsLazyRoute;
  "/_authenticated/_admin/admin/assignment/extensions": typeof AuthenticatedAdminAdminAssignmentExtensionsLazyRoute;
  "/_authenticated/_admin/admin/assignment/invoice-print-styles": typeof AuthenticatedAdminAdminAssignmentInvoicePrintStylesLazyRoute;
  "/_authenticated/_admin/admin/assignment/invoice-types": typeof AuthenticatedAdminAdminAssignmentInvoiceTypesLazyRoute;
  "/_authenticated/_admin/admin/assignment/utilization-codes": typeof AuthenticatedAdminAdminAssignmentUtilizationCodesLazyRoute;
  "/_authenticated/_admin/admin/assignment/work-locations": typeof AuthenticatedAdminAdminAssignmentWorkLocationsLazyRoute;
  "/_authenticated/_admin/admin/assignment/wp-role-codes": typeof AuthenticatedAdminAdminAssignmentWpRoleCodesLazyRoute;
  "/_authenticated/_admin/admin/expense/accounting-categories": typeof AuthenticatedAdminAdminExpenseAccountingCategoriesLazyRoute;
  "/_authenticated/_admin/admin/expense/accounting-codes": typeof AuthenticatedAdminAdminExpenseAccountingCodesLazyRoute;
  "/_authenticated/_admin/admin/expense/expense-subcategories": typeof AuthenticatedAdminAdminExpenseExpenseSubcategoriesLazyRoute;
  "/_authenticated/_admin/admin/expense/reimbursable-expense-exceptions": typeof AuthenticatedAdminAdminExpenseReimbursableExpenseExceptionsLazyRoute;
  "/_authenticated/_admin/admin/expense/subcategory-groups": typeof AuthenticatedAdminAdminExpenseSubcategoryGroupsLazyRoute;
  "/_authenticated/_admin/admin/expense/time-expense-categories": typeof AuthenticatedAdminAdminExpenseTimeExpenseCategoriesLazyRoute;
  "/_authenticated/_admin/admin/other/client-categories": typeof AuthenticatedAdminAdminOtherClientCategoriesLazyRoute;
  "/_authenticated/_admin/admin/other/state-codes": typeof AuthenticatedAdminAdminOtherStateCodesLazyRoute;
  "/_authenticated/_manager/invoice/$invoiceId/": typeof AuthenticatedManagerInvoiceInvoiceIdIndexRoute;
  "/_authenticated/_manager/invoice/$invoiceId/adjustment/create": typeof AuthenticatedManagerInvoiceInvoiceIdAdjustmentCreateRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | "/"
    | "/change-log"
    | "/report"
    | "/account/confirm-email"
    | "/account/forgot-password"
    | "/account/login"
    | "/account/reset-password"
    | "/admin"
    | "/reporting"
    | "/account/change-password"
    | "/account/profile"
    | "/entry/$id"
    | "/entry/create"
    | "/entry/snapshot"
    | "/entry/time"
    | "/admin/assignment"
    | "/admin/expense"
    | "/admin/other"
    | "/admin/power-bi"
    | "/assignment/$assignmentId"
    | "/client/$id"
    | "/client/create"
    | "/invoice/create"
    | "/staff/$id"
    | "/staff/create"
    | "/reporting/$id"
    | "/assignment"
    | "/client"
    | "/invoice"
    | "/staff"
    | "/admin/other/system-info"
    | "/admin/power-bi/settings"
    | "/assignment/create/$clientId"
    | "/invoice/$invoiceId/edit"
    | "/admin/assignment/billing-terms"
    | "/admin/assignment/extensions"
    | "/admin/assignment/invoice-print-styles"
    | "/admin/assignment/invoice-types"
    | "/admin/assignment/utilization-codes"
    | "/admin/assignment/work-locations"
    | "/admin/assignment/wp-role-codes"
    | "/admin/expense/accounting-categories"
    | "/admin/expense/accounting-codes"
    | "/admin/expense/expense-subcategories"
    | "/admin/expense/reimbursable-expense-exceptions"
    | "/admin/expense/subcategory-groups"
    | "/admin/expense/time-expense-categories"
    | "/admin/other/client-categories"
    | "/admin/other/state-codes"
    | "/invoice/$invoiceId"
    | "/invoice/$invoiceId/adjustment/create";
  fileRoutesByTo: FileRoutesByTo;
  to:
    | "/"
    | "/change-log"
    | "/report"
    | "/account/confirm-email"
    | "/account/forgot-password"
    | "/account/login"
    | "/account/reset-password"
    | "/admin"
    | "/reporting"
    | "/account/change-password"
    | "/account/profile"
    | "/entry/$id"
    | "/entry/create"
    | "/entry/snapshot"
    | "/entry/time"
    | "/admin/assignment"
    | "/admin/expense"
    | "/admin/other"
    | "/admin/power-bi"
    | "/assignment/$assignmentId"
    | "/client/$id"
    | "/client/create"
    | "/invoice/create"
    | "/staff/$id"
    | "/staff/create"
    | "/reporting/$id"
    | "/assignment"
    | "/client"
    | "/invoice"
    | "/staff"
    | "/admin/other/system-info"
    | "/admin/power-bi/settings"
    | "/assignment/create/$clientId"
    | "/invoice/$invoiceId/edit"
    | "/admin/assignment/billing-terms"
    | "/admin/assignment/extensions"
    | "/admin/assignment/invoice-print-styles"
    | "/admin/assignment/invoice-types"
    | "/admin/assignment/utilization-codes"
    | "/admin/assignment/work-locations"
    | "/admin/assignment/wp-role-codes"
    | "/admin/expense/accounting-categories"
    | "/admin/expense/accounting-codes"
    | "/admin/expense/expense-subcategories"
    | "/admin/expense/reimbursable-expense-exceptions"
    | "/admin/expense/subcategory-groups"
    | "/admin/expense/time-expense-categories"
    | "/admin/other/client-categories"
    | "/admin/other/state-codes"
    | "/invoice/$invoiceId"
    | "/invoice/$invoiceId/adjustment/create";
  id:
    | "__root__"
    | "/"
    | "/_authenticated"
    | "/change-log"
    | "/_authenticated/_admin"
    | "/_authenticated/_manager"
    | "/_authenticated/report"
    | "/account/confirm-email"
    | "/account/forgot-password"
    | "/account/login"
    | "/account/reset-password"
    | "/_authenticated/_admin/admin"
    | "/_authenticated/_manager/reporting"
    | "/_authenticated/account/change-password"
    | "/_authenticated/account/profile"
    | "/_authenticated/entry/$id"
    | "/_authenticated/entry/create"
    | "/_authenticated/entry/snapshot"
    | "/_authenticated/entry/time"
    | "/_authenticated/_admin/admin/assignment"
    | "/_authenticated/_admin/admin/expense"
    | "/_authenticated/_admin/admin/other"
    | "/_authenticated/_admin/admin/power-bi"
    | "/_authenticated/_manager/assignment/$assignmentId"
    | "/_authenticated/_manager/client/$id"
    | "/_authenticated/_manager/client/create"
    | "/_authenticated/_manager/invoice/create"
    | "/_authenticated/_manager/staff/$id"
    | "/_authenticated/_manager/staff/create"
    | "/_authenticated/_manager/reporting/$id"
    | "/_authenticated/_manager/assignment/"
    | "/_authenticated/_manager/client/"
    | "/_authenticated/_manager/invoice/"
    | "/_authenticated/_manager/staff/"
    | "/_authenticated/_admin/admin/other/system-info"
    | "/_authenticated/_admin/admin/power-bi/settings"
    | "/_authenticated/_manager/assignment/create/$clientId"
    | "/_authenticated/_manager/invoice/$invoiceId/edit"
    | "/_authenticated/_admin/admin/assignment/billing-terms"
    | "/_authenticated/_admin/admin/assignment/extensions"
    | "/_authenticated/_admin/admin/assignment/invoice-print-styles"
    | "/_authenticated/_admin/admin/assignment/invoice-types"
    | "/_authenticated/_admin/admin/assignment/utilization-codes"
    | "/_authenticated/_admin/admin/assignment/work-locations"
    | "/_authenticated/_admin/admin/assignment/wp-role-codes"
    | "/_authenticated/_admin/admin/expense/accounting-categories"
    | "/_authenticated/_admin/admin/expense/accounting-codes"
    | "/_authenticated/_admin/admin/expense/expense-subcategories"
    | "/_authenticated/_admin/admin/expense/reimbursable-expense-exceptions"
    | "/_authenticated/_admin/admin/expense/subcategory-groups"
    | "/_authenticated/_admin/admin/expense/time-expense-categories"
    | "/_authenticated/_admin/admin/other/client-categories"
    | "/_authenticated/_admin/admin/other/state-codes"
    | "/_authenticated/_manager/invoice/$invoiceId/"
    | "/_authenticated/_manager/invoice/$invoiceId/adjustment/create";
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren;
  ChangeLogRoute: typeof ChangeLogRoute;
  AccountConfirmEmailRoute: typeof AccountConfirmEmailRoute;
  AccountForgotPasswordRoute: typeof AccountForgotPasswordRoute;
  AccountLoginRoute: typeof AccountLoginRoute;
  AccountResetPasswordRoute: typeof AccountResetPasswordRoute;
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/change-log": {
      id: "/change-log";
      path: "/change-log";
      fullPath: "/change-log";
      preLoaderRoute: typeof ChangeLogRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_authenticated": {
      id: "/_authenticated";
      path: "";
      fullPath: "";
      preLoaderRoute: typeof AuthenticatedRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/": {
      id: "/";
      path: "/";
      fullPath: "/";
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/account/reset-password": {
      id: "/account/reset-password";
      path: "/account/reset-password";
      fullPath: "/account/reset-password";
      preLoaderRoute: typeof AccountResetPasswordRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/account/login": {
      id: "/account/login";
      path: "/account/login";
      fullPath: "/account/login";
      preLoaderRoute: typeof AccountLoginRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/account/forgot-password": {
      id: "/account/forgot-password";
      path: "/account/forgot-password";
      fullPath: "/account/forgot-password";
      preLoaderRoute: typeof AccountForgotPasswordRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/account/confirm-email": {
      id: "/account/confirm-email";
      path: "/account/confirm-email";
      fullPath: "/account/confirm-email";
      preLoaderRoute: typeof AccountConfirmEmailRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_authenticated/report": {
      id: "/_authenticated/report";
      path: "/report";
      fullPath: "/report";
      preLoaderRoute: typeof AuthenticatedReportRouteImport;
      parentRoute: typeof AuthenticatedRouteRoute;
    };
    "/_authenticated/_manager": {
      id: "/_authenticated/_manager";
      path: "";
      fullPath: "";
      preLoaderRoute: typeof AuthenticatedManagerRouteRouteImport;
      parentRoute: typeof AuthenticatedRouteRoute;
    };
    "/_authenticated/_admin": {
      id: "/_authenticated/_admin";
      path: "";
      fullPath: "";
      preLoaderRoute: typeof AuthenticatedAdminRouteRouteImport;
      parentRoute: typeof AuthenticatedRouteRoute;
    };
    "/_authenticated/entry/time": {
      id: "/_authenticated/entry/time";
      path: "/entry/time";
      fullPath: "/entry/time";
      preLoaderRoute: typeof AuthenticatedEntryTimeRouteImport;
      parentRoute: typeof AuthenticatedRouteRoute;
    };
    "/_authenticated/entry/snapshot": {
      id: "/_authenticated/entry/snapshot";
      path: "/entry/snapshot";
      fullPath: "/entry/snapshot";
      preLoaderRoute: typeof AuthenticatedEntrySnapshotRouteImport;
      parentRoute: typeof AuthenticatedRouteRoute;
    };
    "/_authenticated/entry/create": {
      id: "/_authenticated/entry/create";
      path: "/entry/create";
      fullPath: "/entry/create";
      preLoaderRoute: typeof AuthenticatedEntryCreateRouteImport;
      parentRoute: typeof AuthenticatedRouteRoute;
    };
    "/_authenticated/entry/$id": {
      id: "/_authenticated/entry/$id";
      path: "/entry/$id";
      fullPath: "/entry/$id";
      preLoaderRoute: typeof AuthenticatedEntryIdRouteImport;
      parentRoute: typeof AuthenticatedRouteRoute;
    };
    "/_authenticated/account/profile": {
      id: "/_authenticated/account/profile";
      path: "/account/profile";
      fullPath: "/account/profile";
      preLoaderRoute: typeof AuthenticatedAccountProfileRouteImport;
      parentRoute: typeof AuthenticatedRouteRoute;
    };
    "/_authenticated/account/change-password": {
      id: "/_authenticated/account/change-password";
      path: "/account/change-password";
      fullPath: "/account/change-password";
      preLoaderRoute: typeof AuthenticatedAccountChangePasswordRouteImport;
      parentRoute: typeof AuthenticatedRouteRoute;
    };
    "/_authenticated/_manager/reporting": {
      id: "/_authenticated/_manager/reporting";
      path: "/reporting";
      fullPath: "/reporting";
      preLoaderRoute: typeof AuthenticatedManagerReportingRouteRouteImport;
      parentRoute: typeof AuthenticatedManagerRouteRoute;
    };
    "/_authenticated/_admin/admin": {
      id: "/_authenticated/_admin/admin";
      path: "/admin";
      fullPath: "/admin";
      preLoaderRoute: typeof AuthenticatedAdminAdminRouteRouteImport;
      parentRoute: typeof AuthenticatedAdminRouteRoute;
    };
    "/_authenticated/_manager/staff/": {
      id: "/_authenticated/_manager/staff/";
      path: "/staff";
      fullPath: "/staff";
      preLoaderRoute: typeof AuthenticatedManagerStaffIndexRouteImport;
      parentRoute: typeof AuthenticatedManagerRouteRoute;
    };
    "/_authenticated/_manager/invoice/": {
      id: "/_authenticated/_manager/invoice/";
      path: "/invoice";
      fullPath: "/invoice";
      preLoaderRoute: typeof AuthenticatedManagerInvoiceIndexRouteImport;
      parentRoute: typeof AuthenticatedManagerRouteRoute;
    };
    "/_authenticated/_manager/client/": {
      id: "/_authenticated/_manager/client/";
      path: "/client";
      fullPath: "/client";
      preLoaderRoute: typeof AuthenticatedManagerClientIndexRouteImport;
      parentRoute: typeof AuthenticatedManagerRouteRoute;
    };
    "/_authenticated/_manager/assignment/": {
      id: "/_authenticated/_manager/assignment/";
      path: "/assignment";
      fullPath: "/assignment";
      preLoaderRoute: typeof AuthenticatedManagerAssignmentIndexRouteImport;
      parentRoute: typeof AuthenticatedManagerRouteRoute;
    };
    "/_authenticated/_manager/reporting/$id": {
      id: "/_authenticated/_manager/reporting/$id";
      path: "/$id";
      fullPath: "/reporting/$id";
      preLoaderRoute: typeof AuthenticatedManagerReportingIdLazyRouteImport;
      parentRoute: typeof AuthenticatedManagerReportingRouteRoute;
    };
    "/_authenticated/_manager/staff/create": {
      id: "/_authenticated/_manager/staff/create";
      path: "/staff/create";
      fullPath: "/staff/create";
      preLoaderRoute: typeof AuthenticatedManagerStaffCreateRouteImport;
      parentRoute: typeof AuthenticatedManagerRouteRoute;
    };
    "/_authenticated/_manager/staff/$id": {
      id: "/_authenticated/_manager/staff/$id";
      path: "/staff/$id";
      fullPath: "/staff/$id";
      preLoaderRoute: typeof AuthenticatedManagerStaffIdRouteImport;
      parentRoute: typeof AuthenticatedManagerRouteRoute;
    };
    "/_authenticated/_manager/invoice/create": {
      id: "/_authenticated/_manager/invoice/create";
      path: "/invoice/create";
      fullPath: "/invoice/create";
      preLoaderRoute: typeof AuthenticatedManagerInvoiceCreateRouteImport;
      parentRoute: typeof AuthenticatedManagerRouteRoute;
    };
    "/_authenticated/_manager/client/create": {
      id: "/_authenticated/_manager/client/create";
      path: "/client/create";
      fullPath: "/client/create";
      preLoaderRoute: typeof AuthenticatedManagerClientCreateRouteImport;
      parentRoute: typeof AuthenticatedManagerRouteRoute;
    };
    "/_authenticated/_manager/client/$id": {
      id: "/_authenticated/_manager/client/$id";
      path: "/client/$id";
      fullPath: "/client/$id";
      preLoaderRoute: typeof AuthenticatedManagerClientIdRouteImport;
      parentRoute: typeof AuthenticatedManagerRouteRoute;
    };
    "/_authenticated/_manager/assignment/$assignmentId": {
      id: "/_authenticated/_manager/assignment/$assignmentId";
      path: "/assignment/$assignmentId";
      fullPath: "/assignment/$assignmentId";
      preLoaderRoute: typeof AuthenticatedManagerAssignmentAssignmentIdRouteImport;
      parentRoute: typeof AuthenticatedManagerRouteRoute;
    };
    "/_authenticated/_admin/admin/power-bi": {
      id: "/_authenticated/_admin/admin/power-bi";
      path: "/power-bi";
      fullPath: "/admin/power-bi";
      preLoaderRoute: typeof AuthenticatedAdminAdminPowerBiRouteImport;
      parentRoute: typeof AuthenticatedAdminAdminRouteRoute;
    };
    "/_authenticated/_admin/admin/other": {
      id: "/_authenticated/_admin/admin/other";
      path: "/other";
      fullPath: "/admin/other";
      preLoaderRoute: typeof AuthenticatedAdminAdminOtherRouteImport;
      parentRoute: typeof AuthenticatedAdminAdminRouteRoute;
    };
    "/_authenticated/_admin/admin/expense": {
      id: "/_authenticated/_admin/admin/expense";
      path: "/expense";
      fullPath: "/admin/expense";
      preLoaderRoute: typeof AuthenticatedAdminAdminExpenseRouteImport;
      parentRoute: typeof AuthenticatedAdminAdminRouteRoute;
    };
    "/_authenticated/_admin/admin/assignment": {
      id: "/_authenticated/_admin/admin/assignment";
      path: "/assignment";
      fullPath: "/admin/assignment";
      preLoaderRoute: typeof AuthenticatedAdminAdminAssignmentRouteImport;
      parentRoute: typeof AuthenticatedAdminAdminRouteRoute;
    };
    "/_authenticated/_manager/invoice/$invoiceId/": {
      id: "/_authenticated/_manager/invoice/$invoiceId/";
      path: "/invoice/$invoiceId";
      fullPath: "/invoice/$invoiceId";
      preLoaderRoute: typeof AuthenticatedManagerInvoiceInvoiceIdIndexRouteImport;
      parentRoute: typeof AuthenticatedManagerRouteRoute;
    };
    "/_authenticated/_admin/admin/other/state-codes": {
      id: "/_authenticated/_admin/admin/other/state-codes";
      path: "/state-codes";
      fullPath: "/admin/other/state-codes";
      preLoaderRoute: typeof AuthenticatedAdminAdminOtherStateCodesLazyRouteImport;
      parentRoute: typeof AuthenticatedAdminAdminOtherRoute;
    };
    "/_authenticated/_admin/admin/other/client-categories": {
      id: "/_authenticated/_admin/admin/other/client-categories";
      path: "/client-categories";
      fullPath: "/admin/other/client-categories";
      preLoaderRoute: typeof AuthenticatedAdminAdminOtherClientCategoriesLazyRouteImport;
      parentRoute: typeof AuthenticatedAdminAdminOtherRoute;
    };
    "/_authenticated/_admin/admin/expense/time-expense-categories": {
      id: "/_authenticated/_admin/admin/expense/time-expense-categories";
      path: "/time-expense-categories";
      fullPath: "/admin/expense/time-expense-categories";
      preLoaderRoute: typeof AuthenticatedAdminAdminExpenseTimeExpenseCategoriesLazyRouteImport;
      parentRoute: typeof AuthenticatedAdminAdminExpenseRoute;
    };
    "/_authenticated/_admin/admin/expense/subcategory-groups": {
      id: "/_authenticated/_admin/admin/expense/subcategory-groups";
      path: "/subcategory-groups";
      fullPath: "/admin/expense/subcategory-groups";
      preLoaderRoute: typeof AuthenticatedAdminAdminExpenseSubcategoryGroupsLazyRouteImport;
      parentRoute: typeof AuthenticatedAdminAdminExpenseRoute;
    };
    "/_authenticated/_admin/admin/expense/reimbursable-expense-exceptions": {
      id: "/_authenticated/_admin/admin/expense/reimbursable-expense-exceptions";
      path: "/reimbursable-expense-exceptions";
      fullPath: "/admin/expense/reimbursable-expense-exceptions";
      preLoaderRoute: typeof AuthenticatedAdminAdminExpenseReimbursableExpenseExceptionsLazyRouteImport;
      parentRoute: typeof AuthenticatedAdminAdminExpenseRoute;
    };
    "/_authenticated/_admin/admin/expense/expense-subcategories": {
      id: "/_authenticated/_admin/admin/expense/expense-subcategories";
      path: "/expense-subcategories";
      fullPath: "/admin/expense/expense-subcategories";
      preLoaderRoute: typeof AuthenticatedAdminAdminExpenseExpenseSubcategoriesLazyRouteImport;
      parentRoute: typeof AuthenticatedAdminAdminExpenseRoute;
    };
    "/_authenticated/_admin/admin/expense/accounting-codes": {
      id: "/_authenticated/_admin/admin/expense/accounting-codes";
      path: "/accounting-codes";
      fullPath: "/admin/expense/accounting-codes";
      preLoaderRoute: typeof AuthenticatedAdminAdminExpenseAccountingCodesLazyRouteImport;
      parentRoute: typeof AuthenticatedAdminAdminExpenseRoute;
    };
    "/_authenticated/_admin/admin/expense/accounting-categories": {
      id: "/_authenticated/_admin/admin/expense/accounting-categories";
      path: "/accounting-categories";
      fullPath: "/admin/expense/accounting-categories";
      preLoaderRoute: typeof AuthenticatedAdminAdminExpenseAccountingCategoriesLazyRouteImport;
      parentRoute: typeof AuthenticatedAdminAdminExpenseRoute;
    };
    "/_authenticated/_admin/admin/assignment/wp-role-codes": {
      id: "/_authenticated/_admin/admin/assignment/wp-role-codes";
      path: "/wp-role-codes";
      fullPath: "/admin/assignment/wp-role-codes";
      preLoaderRoute: typeof AuthenticatedAdminAdminAssignmentWpRoleCodesLazyRouteImport;
      parentRoute: typeof AuthenticatedAdminAdminAssignmentRoute;
    };
    "/_authenticated/_admin/admin/assignment/work-locations": {
      id: "/_authenticated/_admin/admin/assignment/work-locations";
      path: "/work-locations";
      fullPath: "/admin/assignment/work-locations";
      preLoaderRoute: typeof AuthenticatedAdminAdminAssignmentWorkLocationsLazyRouteImport;
      parentRoute: typeof AuthenticatedAdminAdminAssignmentRoute;
    };
    "/_authenticated/_admin/admin/assignment/utilization-codes": {
      id: "/_authenticated/_admin/admin/assignment/utilization-codes";
      path: "/utilization-codes";
      fullPath: "/admin/assignment/utilization-codes";
      preLoaderRoute: typeof AuthenticatedAdminAdminAssignmentUtilizationCodesLazyRouteImport;
      parentRoute: typeof AuthenticatedAdminAdminAssignmentRoute;
    };
    "/_authenticated/_admin/admin/assignment/invoice-types": {
      id: "/_authenticated/_admin/admin/assignment/invoice-types";
      path: "/invoice-types";
      fullPath: "/admin/assignment/invoice-types";
      preLoaderRoute: typeof AuthenticatedAdminAdminAssignmentInvoiceTypesLazyRouteImport;
      parentRoute: typeof AuthenticatedAdminAdminAssignmentRoute;
    };
    "/_authenticated/_admin/admin/assignment/invoice-print-styles": {
      id: "/_authenticated/_admin/admin/assignment/invoice-print-styles";
      path: "/invoice-print-styles";
      fullPath: "/admin/assignment/invoice-print-styles";
      preLoaderRoute: typeof AuthenticatedAdminAdminAssignmentInvoicePrintStylesLazyRouteImport;
      parentRoute: typeof AuthenticatedAdminAdminAssignmentRoute;
    };
    "/_authenticated/_admin/admin/assignment/extensions": {
      id: "/_authenticated/_admin/admin/assignment/extensions";
      path: "/extensions";
      fullPath: "/admin/assignment/extensions";
      preLoaderRoute: typeof AuthenticatedAdminAdminAssignmentExtensionsLazyRouteImport;
      parentRoute: typeof AuthenticatedAdminAdminAssignmentRoute;
    };
    "/_authenticated/_admin/admin/assignment/billing-terms": {
      id: "/_authenticated/_admin/admin/assignment/billing-terms";
      path: "/billing-terms";
      fullPath: "/admin/assignment/billing-terms";
      preLoaderRoute: typeof AuthenticatedAdminAdminAssignmentBillingTermsLazyRouteImport;
      parentRoute: typeof AuthenticatedAdminAdminAssignmentRoute;
    };
    "/_authenticated/_manager/invoice/$invoiceId/edit": {
      id: "/_authenticated/_manager/invoice/$invoiceId/edit";
      path: "/invoice/$invoiceId/edit";
      fullPath: "/invoice/$invoiceId/edit";
      preLoaderRoute: typeof AuthenticatedManagerInvoiceInvoiceIdEditRouteImport;
      parentRoute: typeof AuthenticatedManagerRouteRoute;
    };
    "/_authenticated/_manager/assignment/create/$clientId": {
      id: "/_authenticated/_manager/assignment/create/$clientId";
      path: "/assignment/create/$clientId";
      fullPath: "/assignment/create/$clientId";
      preLoaderRoute: typeof AuthenticatedManagerAssignmentCreateClientIdRouteImport;
      parentRoute: typeof AuthenticatedManagerRouteRoute;
    };
    "/_authenticated/_admin/admin/power-bi/settings": {
      id: "/_authenticated/_admin/admin/power-bi/settings";
      path: "/settings";
      fullPath: "/admin/power-bi/settings";
      preLoaderRoute: typeof AuthenticatedAdminAdminPowerBiSettingsRouteImport;
      parentRoute: typeof AuthenticatedAdminAdminPowerBiRoute;
    };
    "/_authenticated/_admin/admin/other/system-info": {
      id: "/_authenticated/_admin/admin/other/system-info";
      path: "/system-info";
      fullPath: "/admin/other/system-info";
      preLoaderRoute: typeof AuthenticatedAdminAdminOtherSystemInfoRouteImport;
      parentRoute: typeof AuthenticatedAdminAdminOtherRoute;
    };
    "/_authenticated/_manager/invoice/$invoiceId/adjustment/create": {
      id: "/_authenticated/_manager/invoice/$invoiceId/adjustment/create";
      path: "/invoice/$invoiceId/adjustment/create";
      fullPath: "/invoice/$invoiceId/adjustment/create";
      preLoaderRoute: typeof AuthenticatedManagerInvoiceInvoiceIdAdjustmentCreateRouteImport;
      parentRoute: typeof AuthenticatedManagerRouteRoute;
    };
  }
}

interface AuthenticatedAdminAdminAssignmentRouteChildren {
  AuthenticatedAdminAdminAssignmentBillingTermsLazyRoute: typeof AuthenticatedAdminAdminAssignmentBillingTermsLazyRoute;
  AuthenticatedAdminAdminAssignmentExtensionsLazyRoute: typeof AuthenticatedAdminAdminAssignmentExtensionsLazyRoute;
  AuthenticatedAdminAdminAssignmentInvoicePrintStylesLazyRoute: typeof AuthenticatedAdminAdminAssignmentInvoicePrintStylesLazyRoute;
  AuthenticatedAdminAdminAssignmentInvoiceTypesLazyRoute: typeof AuthenticatedAdminAdminAssignmentInvoiceTypesLazyRoute;
  AuthenticatedAdminAdminAssignmentUtilizationCodesLazyRoute: typeof AuthenticatedAdminAdminAssignmentUtilizationCodesLazyRoute;
  AuthenticatedAdminAdminAssignmentWorkLocationsLazyRoute: typeof AuthenticatedAdminAdminAssignmentWorkLocationsLazyRoute;
  AuthenticatedAdminAdminAssignmentWpRoleCodesLazyRoute: typeof AuthenticatedAdminAdminAssignmentWpRoleCodesLazyRoute;
}

const AuthenticatedAdminAdminAssignmentRouteChildren: AuthenticatedAdminAdminAssignmentRouteChildren =
  {
    AuthenticatedAdminAdminAssignmentBillingTermsLazyRoute:
      AuthenticatedAdminAdminAssignmentBillingTermsLazyRoute,
    AuthenticatedAdminAdminAssignmentExtensionsLazyRoute:
      AuthenticatedAdminAdminAssignmentExtensionsLazyRoute,
    AuthenticatedAdminAdminAssignmentInvoicePrintStylesLazyRoute:
      AuthenticatedAdminAdminAssignmentInvoicePrintStylesLazyRoute,
    AuthenticatedAdminAdminAssignmentInvoiceTypesLazyRoute:
      AuthenticatedAdminAdminAssignmentInvoiceTypesLazyRoute,
    AuthenticatedAdminAdminAssignmentUtilizationCodesLazyRoute:
      AuthenticatedAdminAdminAssignmentUtilizationCodesLazyRoute,
    AuthenticatedAdminAdminAssignmentWorkLocationsLazyRoute:
      AuthenticatedAdminAdminAssignmentWorkLocationsLazyRoute,
    AuthenticatedAdminAdminAssignmentWpRoleCodesLazyRoute:
      AuthenticatedAdminAdminAssignmentWpRoleCodesLazyRoute,
  };

const AuthenticatedAdminAdminAssignmentRouteWithChildren =
  AuthenticatedAdminAdminAssignmentRoute._addFileChildren(
    AuthenticatedAdminAdminAssignmentRouteChildren,
  );

interface AuthenticatedAdminAdminExpenseRouteChildren {
  AuthenticatedAdminAdminExpenseAccountingCategoriesLazyRoute: typeof AuthenticatedAdminAdminExpenseAccountingCategoriesLazyRoute;
  AuthenticatedAdminAdminExpenseAccountingCodesLazyRoute: typeof AuthenticatedAdminAdminExpenseAccountingCodesLazyRoute;
  AuthenticatedAdminAdminExpenseExpenseSubcategoriesLazyRoute: typeof AuthenticatedAdminAdminExpenseExpenseSubcategoriesLazyRoute;
  AuthenticatedAdminAdminExpenseReimbursableExpenseExceptionsLazyRoute: typeof AuthenticatedAdminAdminExpenseReimbursableExpenseExceptionsLazyRoute;
  AuthenticatedAdminAdminExpenseSubcategoryGroupsLazyRoute: typeof AuthenticatedAdminAdminExpenseSubcategoryGroupsLazyRoute;
  AuthenticatedAdminAdminExpenseTimeExpenseCategoriesLazyRoute: typeof AuthenticatedAdminAdminExpenseTimeExpenseCategoriesLazyRoute;
}

const AuthenticatedAdminAdminExpenseRouteChildren: AuthenticatedAdminAdminExpenseRouteChildren =
  {
    AuthenticatedAdminAdminExpenseAccountingCategoriesLazyRoute:
      AuthenticatedAdminAdminExpenseAccountingCategoriesLazyRoute,
    AuthenticatedAdminAdminExpenseAccountingCodesLazyRoute:
      AuthenticatedAdminAdminExpenseAccountingCodesLazyRoute,
    AuthenticatedAdminAdminExpenseExpenseSubcategoriesLazyRoute:
      AuthenticatedAdminAdminExpenseExpenseSubcategoriesLazyRoute,
    AuthenticatedAdminAdminExpenseReimbursableExpenseExceptionsLazyRoute:
      AuthenticatedAdminAdminExpenseReimbursableExpenseExceptionsLazyRoute,
    AuthenticatedAdminAdminExpenseSubcategoryGroupsLazyRoute:
      AuthenticatedAdminAdminExpenseSubcategoryGroupsLazyRoute,
    AuthenticatedAdminAdminExpenseTimeExpenseCategoriesLazyRoute:
      AuthenticatedAdminAdminExpenseTimeExpenseCategoriesLazyRoute,
  };

const AuthenticatedAdminAdminExpenseRouteWithChildren =
  AuthenticatedAdminAdminExpenseRoute._addFileChildren(
    AuthenticatedAdminAdminExpenseRouteChildren,
  );

interface AuthenticatedAdminAdminOtherRouteChildren {
  AuthenticatedAdminAdminOtherSystemInfoRoute: typeof AuthenticatedAdminAdminOtherSystemInfoRoute;
  AuthenticatedAdminAdminOtherClientCategoriesLazyRoute: typeof AuthenticatedAdminAdminOtherClientCategoriesLazyRoute;
  AuthenticatedAdminAdminOtherStateCodesLazyRoute: typeof AuthenticatedAdminAdminOtherStateCodesLazyRoute;
}

const AuthenticatedAdminAdminOtherRouteChildren: AuthenticatedAdminAdminOtherRouteChildren =
  {
    AuthenticatedAdminAdminOtherSystemInfoRoute:
      AuthenticatedAdminAdminOtherSystemInfoRoute,
    AuthenticatedAdminAdminOtherClientCategoriesLazyRoute:
      AuthenticatedAdminAdminOtherClientCategoriesLazyRoute,
    AuthenticatedAdminAdminOtherStateCodesLazyRoute:
      AuthenticatedAdminAdminOtherStateCodesLazyRoute,
  };

const AuthenticatedAdminAdminOtherRouteWithChildren =
  AuthenticatedAdminAdminOtherRoute._addFileChildren(
    AuthenticatedAdminAdminOtherRouteChildren,
  );

interface AuthenticatedAdminAdminPowerBiRouteChildren {
  AuthenticatedAdminAdminPowerBiSettingsRoute: typeof AuthenticatedAdminAdminPowerBiSettingsRoute;
}

const AuthenticatedAdminAdminPowerBiRouteChildren: AuthenticatedAdminAdminPowerBiRouteChildren =
  {
    AuthenticatedAdminAdminPowerBiSettingsRoute:
      AuthenticatedAdminAdminPowerBiSettingsRoute,
  };

const AuthenticatedAdminAdminPowerBiRouteWithChildren =
  AuthenticatedAdminAdminPowerBiRoute._addFileChildren(
    AuthenticatedAdminAdminPowerBiRouteChildren,
  );

interface AuthenticatedAdminAdminRouteRouteChildren {
  AuthenticatedAdminAdminAssignmentRoute: typeof AuthenticatedAdminAdminAssignmentRouteWithChildren;
  AuthenticatedAdminAdminExpenseRoute: typeof AuthenticatedAdminAdminExpenseRouteWithChildren;
  AuthenticatedAdminAdminOtherRoute: typeof AuthenticatedAdminAdminOtherRouteWithChildren;
  AuthenticatedAdminAdminPowerBiRoute: typeof AuthenticatedAdminAdminPowerBiRouteWithChildren;
}

const AuthenticatedAdminAdminRouteRouteChildren: AuthenticatedAdminAdminRouteRouteChildren =
  {
    AuthenticatedAdminAdminAssignmentRoute:
      AuthenticatedAdminAdminAssignmentRouteWithChildren,
    AuthenticatedAdminAdminExpenseRoute:
      AuthenticatedAdminAdminExpenseRouteWithChildren,
    AuthenticatedAdminAdminOtherRoute:
      AuthenticatedAdminAdminOtherRouteWithChildren,
    AuthenticatedAdminAdminPowerBiRoute:
      AuthenticatedAdminAdminPowerBiRouteWithChildren,
  };

const AuthenticatedAdminAdminRouteRouteWithChildren =
  AuthenticatedAdminAdminRouteRoute._addFileChildren(
    AuthenticatedAdminAdminRouteRouteChildren,
  );

interface AuthenticatedAdminRouteRouteChildren {
  AuthenticatedAdminAdminRouteRoute: typeof AuthenticatedAdminAdminRouteRouteWithChildren;
}

const AuthenticatedAdminRouteRouteChildren: AuthenticatedAdminRouteRouteChildren =
  {
    AuthenticatedAdminAdminRouteRoute:
      AuthenticatedAdminAdminRouteRouteWithChildren,
  };

const AuthenticatedAdminRouteRouteWithChildren =
  AuthenticatedAdminRouteRoute._addFileChildren(
    AuthenticatedAdminRouteRouteChildren,
  );

interface AuthenticatedManagerReportingRouteRouteChildren {
  AuthenticatedManagerReportingIdLazyRoute: typeof AuthenticatedManagerReportingIdLazyRoute;
}

const AuthenticatedManagerReportingRouteRouteChildren: AuthenticatedManagerReportingRouteRouteChildren =
  {
    AuthenticatedManagerReportingIdLazyRoute:
      AuthenticatedManagerReportingIdLazyRoute,
  };

const AuthenticatedManagerReportingRouteRouteWithChildren =
  AuthenticatedManagerReportingRouteRoute._addFileChildren(
    AuthenticatedManagerReportingRouteRouteChildren,
  );

interface AuthenticatedManagerRouteRouteChildren {
  AuthenticatedManagerReportingRouteRoute: typeof AuthenticatedManagerReportingRouteRouteWithChildren;
  AuthenticatedManagerAssignmentAssignmentIdRoute: typeof AuthenticatedManagerAssignmentAssignmentIdRoute;
  AuthenticatedManagerClientIdRoute: typeof AuthenticatedManagerClientIdRoute;
  AuthenticatedManagerClientCreateRoute: typeof AuthenticatedManagerClientCreateRoute;
  AuthenticatedManagerInvoiceCreateRoute: typeof AuthenticatedManagerInvoiceCreateRoute;
  AuthenticatedManagerStaffIdRoute: typeof AuthenticatedManagerStaffIdRoute;
  AuthenticatedManagerStaffCreateRoute: typeof AuthenticatedManagerStaffCreateRoute;
  AuthenticatedManagerAssignmentIndexRoute: typeof AuthenticatedManagerAssignmentIndexRoute;
  AuthenticatedManagerClientIndexRoute: typeof AuthenticatedManagerClientIndexRoute;
  AuthenticatedManagerInvoiceIndexRoute: typeof AuthenticatedManagerInvoiceIndexRoute;
  AuthenticatedManagerStaffIndexRoute: typeof AuthenticatedManagerStaffIndexRoute;
  AuthenticatedManagerAssignmentCreateClientIdRoute: typeof AuthenticatedManagerAssignmentCreateClientIdRoute;
  AuthenticatedManagerInvoiceInvoiceIdEditRoute: typeof AuthenticatedManagerInvoiceInvoiceIdEditRoute;
  AuthenticatedManagerInvoiceInvoiceIdIndexRoute: typeof AuthenticatedManagerInvoiceInvoiceIdIndexRoute;
  AuthenticatedManagerInvoiceInvoiceIdAdjustmentCreateRoute: typeof AuthenticatedManagerInvoiceInvoiceIdAdjustmentCreateRoute;
}

const AuthenticatedManagerRouteRouteChildren: AuthenticatedManagerRouteRouteChildren =
  {
    AuthenticatedManagerReportingRouteRoute:
      AuthenticatedManagerReportingRouteRouteWithChildren,
    AuthenticatedManagerAssignmentAssignmentIdRoute:
      AuthenticatedManagerAssignmentAssignmentIdRoute,
    AuthenticatedManagerClientIdRoute: AuthenticatedManagerClientIdRoute,
    AuthenticatedManagerClientCreateRoute:
      AuthenticatedManagerClientCreateRoute,
    AuthenticatedManagerInvoiceCreateRoute:
      AuthenticatedManagerInvoiceCreateRoute,
    AuthenticatedManagerStaffIdRoute: AuthenticatedManagerStaffIdRoute,
    AuthenticatedManagerStaffCreateRoute: AuthenticatedManagerStaffCreateRoute,
    AuthenticatedManagerAssignmentIndexRoute:
      AuthenticatedManagerAssignmentIndexRoute,
    AuthenticatedManagerClientIndexRoute: AuthenticatedManagerClientIndexRoute,
    AuthenticatedManagerInvoiceIndexRoute:
      AuthenticatedManagerInvoiceIndexRoute,
    AuthenticatedManagerStaffIndexRoute: AuthenticatedManagerStaffIndexRoute,
    AuthenticatedManagerAssignmentCreateClientIdRoute:
      AuthenticatedManagerAssignmentCreateClientIdRoute,
    AuthenticatedManagerInvoiceInvoiceIdEditRoute:
      AuthenticatedManagerInvoiceInvoiceIdEditRoute,
    AuthenticatedManagerInvoiceInvoiceIdIndexRoute:
      AuthenticatedManagerInvoiceInvoiceIdIndexRoute,
    AuthenticatedManagerInvoiceInvoiceIdAdjustmentCreateRoute:
      AuthenticatedManagerInvoiceInvoiceIdAdjustmentCreateRoute,
  };

const AuthenticatedManagerRouteRouteWithChildren =
  AuthenticatedManagerRouteRoute._addFileChildren(
    AuthenticatedManagerRouteRouteChildren,
  );

interface AuthenticatedRouteRouteChildren {
  AuthenticatedAdminRouteRoute: typeof AuthenticatedAdminRouteRouteWithChildren;
  AuthenticatedManagerRouteRoute: typeof AuthenticatedManagerRouteRouteWithChildren;
  AuthenticatedReportRoute: typeof AuthenticatedReportRoute;
  AuthenticatedAccountChangePasswordRoute: typeof AuthenticatedAccountChangePasswordRoute;
  AuthenticatedAccountProfileRoute: typeof AuthenticatedAccountProfileRoute;
  AuthenticatedEntryIdRoute: typeof AuthenticatedEntryIdRoute;
  AuthenticatedEntryCreateRoute: typeof AuthenticatedEntryCreateRoute;
  AuthenticatedEntrySnapshotRoute: typeof AuthenticatedEntrySnapshotRoute;
  AuthenticatedEntryTimeRoute: typeof AuthenticatedEntryTimeRoute;
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedAdminRouteRoute: AuthenticatedAdminRouteRouteWithChildren,
  AuthenticatedManagerRouteRoute: AuthenticatedManagerRouteRouteWithChildren,
  AuthenticatedReportRoute: AuthenticatedReportRoute,
  AuthenticatedAccountChangePasswordRoute:
    AuthenticatedAccountChangePasswordRoute,
  AuthenticatedAccountProfileRoute: AuthenticatedAccountProfileRoute,
  AuthenticatedEntryIdRoute: AuthenticatedEntryIdRoute,
  AuthenticatedEntryCreateRoute: AuthenticatedEntryCreateRoute,
  AuthenticatedEntrySnapshotRoute: AuthenticatedEntrySnapshotRoute,
  AuthenticatedEntryTimeRoute: AuthenticatedEntryTimeRoute,
};

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren);

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  ChangeLogRoute: ChangeLogRoute,
  AccountConfirmEmailRoute: AccountConfirmEmailRoute,
  AccountForgotPasswordRoute: AccountForgotPasswordRoute,
  AccountLoginRoute: AccountLoginRoute,
  AccountResetPasswordRoute: AccountResetPasswordRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
